import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Header from "../common/Header";
import List from "./List/index";
import PermissionMatrix from "./List/PermissionMatrix";
import { hasPermission } from "../../utils/hasPermission";
import { PERM } from "../../utils/permissions";

import "./index.css";

export default function Organization() {
  const userInfo = useSelector((state) => state.userInfo);
  const canManagePermission = hasPermission(userInfo.permissions, PERM.ORG_PERMISSION);

  const [cMenu, setCMenu] = useState("org");
  const [menuDataSource, setMenuDataSource] = useState(null);

  useEffect(() => {
    const menu = [{ id: "org", name: "Organization", selected: true }];
    if (canManagePermission) {
      menu.push({ id: "permission", name: "Permission" });
    }
    setMenuDataSource(menu);
  }, []);

  return (
    <React.Fragment>
      <Header
        title="ORGANIZATION"
        menuDataSource={menuDataSource}
        setCMenu={setCMenu}
      />
      {cMenu === "org" ? <List /> : <PermissionMatrix />}
    </React.Fragment>
  );
}
